import { ReactComponent as LinkSVG } from '@/asset/svg/link.svg'
import Toast from '@/component/Toast'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useCopyToClipboard } from 'react-use'
import ShareChannel from '../ShareChannel'

const ShareMain: React.FC<PropType> = () => {
  const { t } = useTranslation('share')
  const [state, copyToClipboard] = useCopyToClipboard()
  const { params, onFinish } = useStatePopup(PopupSelector.sharePopup)
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)

  const text = `${params?.url}\n${params?.text}`

  const adjustHeight = () => {
    const el = textareaRef.current
    if (!el) return
    el.style.height = 'auto' // 先重置高度，避免高度只增不减
    el.style.height = `${el.scrollHeight}px`
  }

  const handleCopy = () => {
    copyToClipboard(text)
  }

  const handleFinish = () => {
    PopUpStore.setSharePopup({ visible: false, params: undefined, onFinish: undefined })
    onFinish && onFinish()
  }

  useEffect(() => {
    const { error, value } = state

    if (error) {
      Toast.show({
        content: t('message.copyFailed')
      })
    } else if (value) {
      handleFinish()
      Toast.show({
        content: t('message.copySuccess')
      })
    }
  }, [state])

  useEffect(() => {
    adjustHeight() // 初次加载时调整一次
  }, [])

  return (
    <div className="flex flex-col gap-md">
      <div className="flex gap-sm bg-black/10 rounded-md px-md py-sm items-center">
        <div className="flex-grow">
          <textarea
            ref={textareaRef}
            defaultValue={text}
            className="w-full resize-none overflow-hidden bg-transparent active:bg-transparent focus:outline-none text-base"
          />
        </div>
        <button className="hover:bg-black/10 rounded-md p-1" onClick={handleCopy}>
          <LinkSVG className="w-7 h-7 -rotate-45 fill-current" />
        </button>
      </div>
      <div>
        <ShareChannel onFinish={handleFinish} />
      </div>
    </div>
  )
}

interface PropType {}

export default ShareMain
